<popup-c *ngIf="emailInfoPopup?.show" class="threat-protection-popup no-content-padding" size="fullscreen">
	<div class="h100 w100 flxClmn" style="overflow: hidden;" tabindex="0" [appAutoFocus]="true" focusDelay="20" (keydown.escape)="closeQuarantinedPopup();" (keydown.arrowleft)="onThreatNavigate(-1, $event)" (keydown.arrowright)="onThreatNavigate(1, $event)">
		<!--Popup header-->
		<!--CC: header sized by its content (was flex: 1 0 + max-height: 120px), so when the date + summarized analysis row wraps on narrow screens the header grows instead of the row overflowing its bottom border-->
		<div class="flxClmn-around tp-popup-header" style="flex: 0 0 auto; padding: 10px 20px; border-bottom: solid 1px var(--ui-border); z-index: 100; background: var(--ui-surface);">
			<div class="flxRow-between">
				<div class="flxRow ellipsis hSpace2" style="align-items: center; padding-right: 5%;">
					<img src="images/favicon/favicon-32x32.png" style="width: 20px; margin: 0; image-rendering: -webkit-optimize-contrast;">
					<h3 class="ellipsis">{{curEmail.subject}}</h3>
					<div *ngIf="reviewerInfo.is_security_reviewer && !this.loadQuarantineData" style="font-size: 16px; margin-top: 3px;">
						<span><strong>Subject Filter: </strong>{{this.quarantineSubjectFiltersMatchEMDR || 'No Match'}}</span>
						<i style="margin-left: 5px;" class="far" [ngStyle]="{'color': this.quarantineSubjectFiltersMatchEMDR ? 'darkgreen' : 'darkred'}"
						   [ngClass]="this.quarantineSubjectFiltersMatchEMDR ? 'fa-check-circle' : 'fa-times-circle'"></i>
						<span style="margin-left: 15px;">
							<strong>Related Brand: </strong>{{curTPResults?.resHead?.relatedBrand || 'None'}}
						</span>
					</div>
				</div>
				<div class="flxRow">
					<a (click)="closeQuarantinedPopup();">
						<i class="far fa-times" style="font-size: 1.3rem; padding: 10px;"></i>
					</a>
				</div>
			</div>

			<div class="flxRow hSpace2" style="align-items: center; flex-wrap: wrap; row-gap: 8px;">
				<!--quarantinedCategories: ['Malicious', 'Suspicious', 'Spam', 'Graymail', 'External', 'Safe'],-->
				<ng-container *ngIf="emailInfoPopup.category">
					<!--CC: category chip - same tinted pill as the email activity table-->
					<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 6px; margin: 0 0 0 30px; padding: 5px 13px; flex-shrink: 0; white-space: nowrap;"
						 [ngClass]="setInboundStatusStyles(emailInfoPopup.category).color">
						<div class="threat-tag-BG"></div>
						<i class="far threat-tag-icon" style="font-size: 12px;"
						   [ngClass]="emailInfoPopup.category === 'Safe' ? 'fa-check' : emailInfoPopup.category === 'External' ? 'fa-external-link-alt' : (emailInfoPopup.category === 'Spam' || emailInfoPopup.category === 'Graymail') ? 'fa-exclamation-circle' : 'fas fa-biohazard'">
						</i>
						<span class="threat-tag-text" style="font-size: 13px; font-weight: 600;">{{emailInfoPopup.category}}</span>
					</div>
				</ng-container>

				<!--CC: status as a chip (Released / Quarantined / ...) instead of the "This email is ..." sentence-->
				<div class="flxRow hSpace1" style="align-items: center;">
					<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 6px; margin: 0; padding: 5px 13px; flex-shrink: 0; white-space: nowrap;"
						 [ngClass]="curEmail?.status === dic.CONSTANTS.quarantinedActions.quarantine.value && 'darkorange' || curEmail?.status === dic.CONSTANTS.quarantinedActions.quarantine.display && 'darkorange' || curEmail.status === dic.CONSTANTS.quarantinedActions.release.value && 'darkgreen' || curEmail.status === dic.CONSTANTS.quarantinedActions.remove.value && 'darkred' || curEmail.status === dic.CONSTANTS.quarantinedActions.pending.value && 'dimgray' || curEmail.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value && 'darkred' || 'dimgray'">
						<div class="threat-tag-BG"></div>
						<!--CC: single line - threat-tag-text is pre-wrap, so template newlines rendered as a second line (QA)-->
						<span class="threat-tag-text" style="font-size: 13px; font-weight: 600;">{{(curEmail.status === dic.CONSTANTS.quarantinedActions.release.value ? 'released' : curEmail.status === dic.CONSTANTS.quarantinedActions.remove.value ? 'removed' : curEmail.status === dic.CONSTANTS.quarantinedActions.pending.value ? 'pending release' : curEmail.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value ? 'release failure' : curEmail.status) | titlecase}}</span>
					</div>
					<i *ngIf="curEmail.reason" class="far fa-question-circle" style="font-weight: 400; color: var(--ui-text-muted);" tooltip="{{curEmail.reason}}"></i>
				</div>
				<div class="vertical-separator" style="border-width: 1px; margin: 0 0.75vw; border-color: var(--ui-border-strong); border-left: none; height: 22px; align-self: center;"></div>
				<!--CC: mailbox block has a 0 flex-basis and shrinks (dropdown down to 180px) so the date + summarized analysis group stays on the first row instead of wrapping; it wraps only below 300px-->
				<div class="flxRow hSpace1" style="align-items: center; flex: 1 1 0; min-width: 300px;">
					<span style="color: var(--ui-text-muted); font-size: 1rem; white-space: nowrap;">Mailbox:</span>
					<app-dropdown-c style="width: 320px; min-width: 180px; flex-shrink: 1; height: 36px; --bs-dropdown-max-height: unset; --bs-dropdown-overflow: auto;"
									[enableSearch]="true" [isEllipsis]="true"
									[items]="curEmail.visibleEmails"
									itemDisplayKey="mailbox_email"
									(onItemClicked)="changeRecipientThreats($event.item)"
									*ngIf="curEmail?.parent && curEmail?.visibleEmails?.length > 1"
									text="{{curEmail?.curRecipient?.mailbox_email}}"></app-dropdown-c>
					<input type="text" readonly style="width: 320px; min-width: 180px; flex-shrink: 1; height: 36px; margin: 0; font-size: 14px; cursor: default;"
						   onclick="return false"
						   *ngIf="!curEmail?.parent || curEmail?.visibleEmails?.length === 1"
						   [value]="curEmail.mailbox_email?.toString()" />
					<!--CC: mailbox role (job title / executive) - admins can edit it from here-->
					<ng-container *ngIf="curTPResults?.resHead">
						<i *ngIf="curTPResults?.resHead?.isExecutiveRecipient"
						   class="far fa-user-tie" style="color: var(--ui-success);"
						   tooltip="{{curTPResults?.resHead?.recipientJobTitle || 'Executive Role'}}">
						</i>
						<span class="ellipsis" style="color: var(--ui-text-muted); font-size: 13px; max-width: 150px;"
							  *ngIf="curTPResults?.resHead?.recipientJobTitle"
							  tooltip="{{curTPResults?.resHead?.recipientJobTitle}}">{{curTPResults?.resHead?.recipientJobTitle}}</span>
						<a class="hvr-opacity" style="color: var(--ui-text-muted);" *ngIf="isAdminUser"
						   tooltip="{{curTPResults?.resHead?.recipientJobTitle ? 'Edit mailbox role' : 'Set mailbox role'}}"
						   (click)="openMailboxRolePopup()">
							<i class="far fa-edit"></i>
						</a>
					</ng-container>
				</div>
				<!--received date + summarized analysis stay together on the right (they wrap as one group, the date never drops alone)-->
				<div class="flxRow-end f-1-0 hSpace2" style="align-items: center; flex-wrap: nowrap;">
					<div class="flxRow hSpace1" style="align-items: center; flex-shrink: 0;">
						<i class="far fa-clock" style="font-size: 1rem; color: var(--ui-text-muted);"></i>
						<span style="font-size: 1rem; color: var(--ui-text-muted); white-space: nowrap;"
							  [tooltip]="moment(curEmail.created).format('dddd, MMMM Do YYYY, h:mm A')">{{moment(curEmail.created).format('MMM D, YYYY, h:mm A')}} ({{moment(curEmail.created).fromNow()}})</span>
					</div>
					<span [tooltip]="dic.CONSTANTS.openAiDataset.summarizedAnalysisUnavailable" [display]="!curEmail.allowSummarizedAnalysis">
						<btn-c class="popup-action-btn bs-enabled"
							   startIcon="fa fa-magic"
							   [loading]="curEmail.getAiAnalysisInProcess"
							   [isDisabled]="curEmail.showAiAnalysis || !curEmail.allowSummarizedAnalysis"
							   (action)="curEmail.aiAnalysisData ? curEmail.showAiAnalysis = true : selectAction(curEmail, dic.CONSTANTS.quarantinedActions.AIanalysis.display);">
							Summarized Analysis
						</btn-c>
					</span>
				</div>
			</div>
		</div>

		<div class="flxRow" style="flex: 8 0; overflow: auto;">
			<!--Sidebar-->
			<div class="flxClmn tp-popup-sidebar" style="border-right: solid 1px var(--ui-border); background: var(--ui-surface-2); position: sticky; left: 0; top: 0; z-index: 50;">
				<div class="flxClmn" style="padding: max(1.2vw,15px);">
					<!--Analysis Summary-->
					<div class="flxClmn vSpace1">
						<div class="flxRow-between" style="margin-bottom: min(15px,1vh);">
							<div class="flxClmn w100 vSpace05">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">Summary</span>
								<div style="background: var(--ui-border); width: 100%; height: 1px;"></div>
							</div>
						</div>
						<div class="flxRow hSpace1" style="align-items: flex-start;"
							 *ngIf="curTPResults?.resHead?.message"
							 [ngStyle]="{'color': setInboundStatusStyles(curTPResults?.headerStatus).color}">
							<i class="far fa-user" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
							<div class="flxClmn vSpace05" style="color: initial;">
									<span>
										{{curTPResults.resHead.message}}
										<i *ngIf="curTPResults.resHead.sub_status_description"
										   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
										   tooltip="{{curTPResults.resHead.sub_status_description}}"
										   placement="right"></i>
									</span>
								<span style="word-break: break-word;"
									  *ngIf="curTPResults?.resHead?.from && curTPResults?.resHead?.from?.highlight"
									  [innerHTML]="curTPResults.resHead.from.highlight"></span>
							</div>
						</div>
						<div class="flxRow hSpace1" style="align-items: flex-start;"
							 *ngIf="curTPResults?.resUrl?.message"
							 [ngStyle]="{'color': setInboundStatusStyles(curTPResults?.urlStatus).color}">
							<i class="far fa-link" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
							<div class="flxClmn vSpace05" style="color: initial;">
									<span>
										{{curTPResults.resUrl.message}}
										<i *ngIf="curTPResults.resUrl.sub_status_description"
										   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
										   tooltip="{{curTPResults.resUrl.sub_status_description}}"
										   placement="right"></i>
									</span>
								<span style="word-break: break-word;"
									  *ngIf="curTPResults?.resUrl?.highlight"
									  [innerHTML]="curTPResults.resUrl.highlight"></span>
							</div>
						</div>
						<div class="flxRow hSpace1" style="align-items: flex-start;"
							 *ngIf="curTPResults?.resHash?.message"
							 [ngStyle]="{'color': setInboundStatusStyles(curTPResults?.hashStatus).color}">
							<i class="far fa-file" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
							<div class="flxClmn vSpace05" style="color: initial;">
									<span>
										{{curTPResults?.resHash?.message}}
										<i *ngIf="curTPResults.resHash.sub_status_description"
										   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
										   tooltip="{{curTPResults.resHash.sub_status_description}}"
										   placement="right"></i>
									</span>
								<span style="word-break: break-word;"
									  *ngIf="curTPResults?.resHash?.highlight"
									  [innerHTML]="curTPResults.resHash.highlight"></span>
							</div>
						</div>

						<div class="f-1-0 flex-column" style="align-items: center; margin-top: 30px;" *ngIf="curTPResults?.rescan_in_process">
							<loader height="35" width="35" style="opacity: 0.8;"></loader>
							<span>Rescan in process...</span>
						</div>
					</div>
				</div>
				<hr style="margin: 0;" *ngIf="curTPResults"/>
				<!--Actions-->
				<div class="flxClmn-between" style="flex: 1 0; overflow: auto;">
					<div class="flxClmn animated fadeIn" style="padding: max(1.2vw,15px);" *ngIf="curTPResults">
						<!--email actions-->
						<div class="flxClmn" style="flex-shrink: 0;">
							<div class="flxClmn w100 vSpace05">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">Email Actions</span>
								<div style="background: var(--ui-border); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
							</div>
							<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.remove.value) >= 0"
									   btnTooltip="The email will be removed completely from the recipient's mailbox." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.remove.display)">
									Remove
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.release.value) >= 0"
									   btnTooltip="The email will be released to {{isParentQuarantined ? 'all recipient mailboxes' : 'the recipient\'s mailbox.'}}" btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.release.display)">
									{{isParentQuarantined ? 'Release all' : 'Release'}}
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.requestRelease.value) >= 0"
									   btnTooltip="Sends a request to admins to release this message to your mailbox. This does not release the email immediately" btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.requestRelease.display)">
									Release Request
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.requestedReleaseReject.value) >= 0"
									   btnTooltip="Reject release request for this email." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.requestedReleaseReject.display)">
									Reject Release Request
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.linksWhitelist.value) >= 0"
									   btnTooltip="All non-safe links contained in this email will now be considered safe." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.linksWhitelist.display)">
									Allowlist Links
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.signature.value) >= 0"
									   btnTooltip="The source will be signed and considered safe and valid for this domain." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.signature.display)">
									Sign Source
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.removeSource.value) >= 0"
									   btnTooltip="The source will be removed from the trusted sources of this domain." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.removeSource.display)">
									Remove Source
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.allowFileType.value) >= 0"
									   btnTooltip="The blocked file type will be set as allowed." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.allowFileType.display)">
									Allow File Type
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Change the category of this email to safe, external, spam, graymail, suspicious, or malicious." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.setCategory.display)">
									Set Category
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.rescan.value) >= 0"
									   btnTooltip="Rescan email and update threat analysis results." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.rescan.display)">
									Rescan Email
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0" style="font-size: 12px;"
									   [btnTooltip]="curEmail.keep_forever ? 'Allow this email to be deleted by the default retention policy.' : 'Select the email to be preserved and not be deleted by the default retention policy.'"
									   btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, curEmail.keep_forever ? 'Do not preserve record' : 'Preserve record')">
									{{curEmail.keep_forever ? 'Do not preserve record' : 'Preserve Record'}}
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="This email will be marked as {{curEmail.reviewed_completed ?  'not ' : ''}}handled by a reviewer" btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.handled.display);">
									{{curEmail.reviewed_completed ? 'Set not handled' : 'Set handled'}}
								</btn-c>
							</div>
						</div>

						<!--sender actions-->
						<div class="flxClmn" style="margin-top: 2vh; flex-shrink: 0;">
							<div class="flxClmn w100 vSpace05">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">Sender Actions</span>
								<div style="background: var(--ui-border); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
							</div>
							<!--sender actions-->
							<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.senderMethods.indexOf(dic.CONSTANTS.quarantinedActions.whitelist.value) >= 0"
									   btnTooltip="Emails from this sender will be released and arrive to the recipient's inbox." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.whitelist.display);">
									Allowlist
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   *ngIf="curEmail.senderMethods.indexOf(dic.CONSTANTS.quarantinedActions.blacklist.value) >= 0"
									   btnTooltip="Emails from this sender will be removed completely from the recipient mailbox." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.blacklist.display)">
									Blocklist
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Ask the sender to confirm their identity." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.authSender.display)">
									Authenticate
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Trust this sender for all users in the plan. Emails from trusted senders are less likely to be considered spam or as threats." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.trustSender.display);">
									Trust Sender
								</btn-c>
							</div>
						</div>

						<!--SAT actions-->
						<div class="flxClmn" style="margin-top: 2vh; flex-shrink: 0;" *ngIf="planInfo?.tsEnabled && planInfo?.allowReviewerShowContent">
							<div class="flxClmn w100 vSpace05">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">Threat Simulation Actions</span>
								<div style="background: var(--ui-border); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
							</div>
							<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Create threat simulation template out of this email." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.threatSimulationTemplate.display)">
									Create Template
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   style="font-size: 0.75rem;"
									   btnTooltip="Create AI training video based on the email content." btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.aiTrainingMaterial.display)">
									Create AI training video
								</btn-c>
							</div>
						</div>

						<!--security reviewer-->
						<div class="flxClmn" *ngIf="reviewerInfo.is_security_reviewer" style="margin-top: 2vh; flex-shrink: 0;">
							<div class="flxClmn w100 vSpace05" style="margin-top: 10px;">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted);">Security Reviewer Actions</span>
								<div style="background: var(--ui-border); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
							</div>
							<!--email actions-->
							<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Send query to reviewers of the inbound shield" btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.createIncident.display)">
									Create Incident
								</btn-c>
								<btn-c class="quarantined-popup-action-btn f-1-0"
									   btnTooltip="Security reviewer activity for generate report" btnTooltipDirection="right"
									   [isDisabled]="loadQuarantineData"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.securityReviewerActivity.display)">
									Reviewer Activity
								</btn-c>
							</div>
						</div>
					</div>
					<div class="flxClmn-center" style="margin-top: -5px; padding: 0 4% 2vh; align-items: center; min-height: 45px; flex-shrink: 0;">
						<div class="loading-spinner" style="position: relative; left: unset; top: unset;" *ngIf="loadQuarantineData && !curEmail.loadingEmailContent"></div>
						<span [ngStyle]="{'color': popupError.error.type === 'info' ? 'darkgreen':'#e84634'}" style="text-align: center; padding: 3%; border-radius: 5px; background: white;"
							  *ngIf="(popupError && popupError.error && popupError.error.message || '') && !loadQuarantineData">
								{{popupError && popupError.error && popupError.error.message || ' '}}
							</span>
					</div>
				</div>
			</div>
			<div class="flxClmn" style="flex: 1 0; position: relative;">
				<div class="flxClmn centralize w100 bs-enabled animated fadeIn" style="position: absolute; z-index: 50; top: 0; left: 0; bottom: 0; right: 0; background: #4f545dab; backdrop-filter: blur(7px);"
					 *ngIf="(curEmail.getAiAnalysisInProcess || curEmail.showAiAnalysis)">
					<div class="bg-white flex-column p-2 rounded-2" style="width: 100%; max-width: 600px; line-height: 1.6; min-height: 170px;">
						<div class="rounded-2 f-1-0 flex-column justify-content-center p-4 position-relative"
							 style="box-shadow: 0 0 3px {{setInboundStatusStyles(curEmail.malicious.status).color}}">
							<div class="flex-column centralize f-1-0 gap-2" *ngIf="curEmail.getAiAnalysisInProcess">
								<loader height="75" width="75" style="opacity: 0.8;"></loader>
								<span class="loading-dots">Analyzing email data. It might take a while</span>
							</div>
							<div class="flex-row gap-4 align-items-center animated fadeIn" *ngIf="curEmail.aiAnalysisData">
								<i class="far fa-info-circle" style="font-size: 3rem"
								   [style.color]="setInboundStatusStyles(curEmail.malicious.status).color"></i>
								<span class="ai-tp-analysis-desc fw-500" style="font-size: 20px;"
									  [ngStyle]="{'--ai-tp-analysis-color' : setInboundStatusStyles(curEmail.malicious.status).color} ">
										<span [innerHTML]="curEmail.aiAnalysisData || ''"></span>
										<ng-container *ngIf="emailInfoPopup.category && emailInfoPopup.category !== curEmail.malicious.status">
											<br/>
											<span style="font-weight: normal; font-size: 15px;">
												Later, the user changed this classification to <b [style.color]="setInboundStatusStyles(emailInfoPopup.category).color">{{emailInfoPopup.category}}</b>.
											</span>
										</ng-container>
									</span>
							</div>
							<i class="far fa-times cursor-pointer hvr-opacity px-1 animated fadeIn"
							   style="transition: all 0.5s; position: absolute; top: 5px; right: 5px; font-size: 18px;"
							   (click)="curEmail.showAiAnalysis = false;"></i>
						</div>
					</div>
				</div>

				<div class="threat-protection-grid h100 animated fadeIn" style="flex: 1 0; overflow: auto; padding: 0 0.75vw;">
					<!--Message Analysis Data Card-->
					<div class="threat-protection-card flxClmn ro18 co7 md-co12" style="min-height: 755px; max-height: 75vh;"
						 [ngClass]="{'co12' : !planInfo?.allowReviewerShowContent}">
						<div class="card-header flxRow-between" style="align-items: center;">
								<span class="card-title"
									  [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.resHead?.status).color === 'darkred' ? 'darkred' : ''}">
									Message Analysis
								</span>
							<div class="flxRow hSpace1" style="align-items: center;">
								<i class="far hvr-opacity animated fadeIn" style="font-size: 1rem;" *ngIf="curTPResults?.resHead && curTPResults.resHead.status !== dic.CONSTANTS.threatProtection.status.safe && !curTPResults.resHead.sub_status?.length"
								   [ngClass]="setInboundStatusStyles(curTPResults?.resHead?.status).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults.headerStatus).icon"
								   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.resHead?.status).color}"
								   tooltip="{{curTPResults.resHead.message || 'Some headers were found malicious or suspicious'}}"></i>
								<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 5px; margin: 0;"
									 *ngIf="curTPResults?.resHead && (curTPResults.resHead.status === dic.CONSTANTS.threatProtection.status.safe || curTPResults.resHead.sub_status?.length)"
									 [ngClass]="setInboundStatusStyles(curTPResults?.resHead?.status).color">
									 <div class="threat-tag-BG"></div>
									 <i class="far threat-tag-icon" [ngClass]="curTPResults.resHead.status === dic.CONSTANTS.threatProtection.status.safe ? 'fa-check-circle' : setInboundStatusStyles(curTPResults?.resHead?.status).icon"></i>
									 <span class="threat-tag-text">{{curTPResults.resHead.status === dic.CONSTANTS.threatProtection.status.safe ? dic.CONSTANTS.threatProtection.status.safe : curTPResults.resHead.sub_status}}</span>
								</div>
								<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
							</div>
						</div>
						<div class="flxClmn animated fadeIn" style="flex: 1 0; overflow: auto;" *ngIf="curTPResults">
							<div class="flxClmn vSpace05" style="padding: 15px 10px;">
								<div class="flxRow">
									<span style="font-weight: 600;">Sender Identities</span>
									<span style="margin-left: auto; color: blue; cursor: pointer;"
										  *ngIf="viewEmailsFromSenderCb.observed"
										  (click)="viewEmailFromSender()">
										View other emails from this sender
									</span>
								</div>
								<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
									<tr>
										<th style="width: 100px; padding: 0;"></th>
										<th style="padding: 0;"></th>
										<th style="width: 30px; padding: 0;"></th>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.senderMail && curTPResults?.resHead?.from?.senderMail !== curTPResults?.resHead?.from?.senderMailFrom">
										<td>
											<span><b>Appears As</b></span>
										</td>
										<td>
											<span style="padding: 0; white-space: normal; word-break: break-word;" (click)="copyItemToClipboard(curTPResults.resHead.from.senderMail);">{{curTPResults.resHead.from.senderMail}}</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.appearsAs" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.senderMailFrom">
										<td>
											<span><b>Sender</b></span>
										</td>
										<td>
											<span style="padding: 0; white-space: normal; word-break: break-word;" (click)="copyItemToClipboard(curTPResults.resHead.from.senderMailFrom);">{{curTPResults.resHead.from.senderMailFrom}}</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.sender" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead && curTPResults?.resHead?.relationshipLevel">
										<td><b>Relationship</b></td>
										<td>
											<div class="flxClmn vSpace1">
												<div class="flxRow hSpace1">
													<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
														<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
															 [ngStyle]="{ 'width': (curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total ? (curTPResults.resHead.relationshipLevel.total * 0.95 + 5)  : 5) + '%', 'background-color': curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total >= 70 ? 'darkgreen' : curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total >= 50 ? 'darkorange' : 'darkred'}"></div>
													</div>
													<span>{{curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total || 0}}%</span>
												</div>
												<a class="blue-link hSpace05" (click)="showRelationshipConnectionGraph();">
													<i class="far fa-project-diagram" style=" font-size: 0.65rem;"></i>
													<span>View connections graph</span>
												</a>
											</div>
										</td>
										<td>
											<i style="font-weight: 400; font-size: 0.9rem; display: flex; justify-content: center;" class="far fa-question-circle checkmark" tooltip="Sender's relationship level with the user and organisation.<br/>This score is calculated at the time the email was received and does not reflect changes that were made after that time."></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.replyTo">
										<td>
											<span><b>Reply To</b></span>
										</td>
										<td>
											<span style="padding: 0; white-space: normal; word-break: break-word;" (click)="copyItemToClipboard(curTPResults.resHead.from.replyTo);">{{curTPResults.resHead.from.replyTo}}</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.replyTo" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.returnPath">
										<td>
											<span><b>Return Path</b></span>
										</td>
										<td>
											<span style="padding: 0; white-space: normal; word-break: break-word;" (click)="copyItemToClipboard(curTPResults.resHead.from.returnPath);">{{curTPResults.resHead.from.returnPath}}</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.returnPath" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.messageID">
										<td>
											<span><b>Message ID</b></span>
										</td>
										<td>
											<span style="word-break: break-all;" (click)="copyItemToClipboard(curTPResults.resHead.from.messageID);">{{curTPResults.resHead.from.messageID}}</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.messageId" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.sendingMTA?.domain">
										<td>
											<span><b>MTA Domain</b></span>
										</td>
										<td>
											<div class="mta-connecting-host-cell">
												<span class="mta-connecting-hostname">{{curTPResults.resHead.from.sendingMTAFull || curTPResults.resHead.from.sendingMTA.domain}}</span>
												<span class="mta-domain-ip-value" *ngIf="curTPResults.resHead.from.sendingMTAIP">{{curTPResults.resHead.from.sendingMTAIP}}</span>
											</div>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.mta" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from?.ipAddresses && curTPResults?.resHead?.from?.ipAddresses?.length">
										<td>
											<span><b>IP Addresses</b></span>
										</td>
										<td>
												<span class="mta-ip-addresses-list">
													<ng-container *ngFor="let ip of threatAnalysisIpAddressesMtaFirst(curTPResults.resHead.from); let i = index">
														<span *ngIf="i > 0" class="mta-ip-addresses-sep" aria-hidden="true">,</span>
														<ng-container *ngIf="ipMatchesThreatAnalysisSendingMta(curTPResults.resHead.from, ip)">
															<span class="mta-address-ip-with-tag">
																<span class="mta-address-ip-text">{{ip}}</span>
																<span class="mta-address-tag">MTA</span>
															</span>
														</ng-container>
														<span *ngIf="!ipMatchesThreatAnalysisSendingMta(curTPResults.resHead.from, ip)">{{ip}}</span>
													</ng-container>
												</span>
										</td>
										<td>
											<sr-row-action [cell]="true" *ngIf="reviewerInfo.is_security_reviewer" [targets]="senderRowTargets.ip" [allowPlan]="planInfo?.allowGlobalAllowBlockLists" (apply)="doRowAction($event, 'sender')"></sr-row-action>
										</td>
									</tr>
								</table>
							</div>
							<div class="flxClmn vSpace05" style="padding: 15px 10px;">
								<span style="font-weight: 600;">AI Confidence</span>
								<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
									<tr>
										<th style="width: 100px; padding: 0;"></th>
										<th style="padding: 0;"></th>
										<th style="width: 30px; padding: 0;"></th>
									</tr>
									<tr>
										<td>
											<span><b>AI Decision</b></span>
										</td>
										<td>
											   <span style="text-transform: capitalize;"
													 *ngIf="!curTPResults?.resHead?.AIresults?.skip">
												   {{!curTPResults.resHead.AIresults.decision ? 'Safe' : curTPResults.resHead.AIresults.decision === 'threat' ? 'Business Email Compromise (BEC)' : curTPResults.resHead.AIresults.decision}}
											   </span>
											<span style="text-transform: capitalize;" *ngIf="curTPResults?.resHead?.AIresults?.skip">
												   {{curTPResults.resHead.AIresults.decision ? curTPResults.resHead.AIresults.decision : 'Internal metrics decision'}}
											   </span>
										</td>
										<td>
											<i style="font-weight: 400;" class="far fa-question-circle checkmark" tooltip="The final AI decision for this email, based on the AI score for BEC, Spam, and Graymail.<br/> The final email status may differ from the AI decision, due to link and attachment analysis."></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.AIresults">
										<td>
											<span><b>- BEC AI</b></span>
										</td>
										<td>
											<div class="flxRow hSpace1" (ngInit)="threat_body_conf_precentages = curTPResults.resHead.AIresults.threat_body_conf ? curTPResults.resHead.AIresults.threat_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.threat_body_conf * 100) : 0">
												<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
													<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
														 [ngStyle]="{ 'width': threat_body_conf_precentages + '%', 'background-color' : threat_body_conf_precentages <= 50 ? 'darkgreen' : threat_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
												</div>
												<span style="flex-basis: 32px;">{{threat_body_conf_precentages | number: 0}}%</span>
											</div>
										</td>
										<td>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.AIresults">
										<td>
											<span><b>- Spam AI</b></span>
										</td>
										<td>
											<div class="flxRow hSpace1" (ngInit)="spam_body_conf_precentages = curTPResults.resHead.AIresults.spam_body_conf ? curTPResults.resHead.AIresults.spam_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.spam_body_conf * 100) : 0">
												<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
													<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
														 [ngStyle]="{ 'width': spam_body_conf_precentages + '%', 'background-color' : spam_body_conf_precentages <= 50 ? 'darkgreen' : spam_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
												</div>
												<span style="flex-basis: 32px;">{{spam_body_conf_precentages | number: 0}}%</span>
											</div>
										</td>
										<td>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.AIresults">
										<td>
											<span><b>- Graymail AI</b></span>
										</td>
										<td>
											<div class="flxRow hSpace1" (ngInit)="graymail_body_conf_precentages = curTPResults.resHead.AIresults.graymail_body_conf ? curTPResults.resHead.AIresults.graymail_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.graymail_body_conf * 100) : 0">
												<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
													<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
														 [ngStyle]="{ 'width': graymail_body_conf_precentages + '%', 'background-color' : graymail_body_conf_precentages <= 50 ? 'darkgreen' : graymail_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
												</div>
												<span style="flex-basis: 32px;">{{graymail_body_conf_precentages | number: 0}}%</span>
											</div>
										</td>
										<td>
										</td>
									</tr>
								</table>
							</div>
							<div class="flxClmn vSpace05" style="padding: 15px 10px;">
								<span style="font-weight: 600;">Authentication Standards</span>
								<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
									<tr>
										<th style="width: 100px; padding: 0;"></th>
										<th style="padding: 0;"></th>
										<th style="width: 30px; padding: 0;"></th>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.spf">
										<td>
											<span><b>SPF</b></span>
										</td>
										<td>
											<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.spf.message ? curTPResults.resHead.spf.message : (curTPResults.resHead.from.isInternal ? 'SPF is Internal' : 'No SPF was sent.')}}</span>
										</td>
										<td>
											<i *ngIf="!curTPResults.resHead.spf.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
											<i class="far" *ngIf="curTPResults.resHead.spf.message" [ngClass]="curTPResults.resHead.spf.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.spf.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.arc">
										<td>
											<span><b>ARC</b></span>
										</td>
										<td>
											<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.arc.message ? curTPResults.resHead.arc.message : (curTPResults.resHead.from.isInternal ? 'ARC is Internal' : 'No ARC was sent.')}}</span>
										</td>
										<td>
											<i *ngIf="!curTPResults?.resHead?.arc?.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
											<i class="far" *ngIf="curTPResults?.resHead?.arc?.message" [ngClass]="curTPResults.resHead.arc.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.arc.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.dkim">
										<td><b>DKIM</b></td>
										<td>
											<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.dkim.message ? curTPResults.resHead.dkim.message : (curTPResults.resHead.from.isInternal ? 'DKIM is Internal' : 'No DKIM was sent')}}</span>
										</td>
										<td>
											<i *ngIf="!curTPResults?.resHead?.dkim?.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
											<i class="far" *ngIf="curTPResults?.resHead?.dkim?.message" [ngClass]="curTPResults.resHead.dkim.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.dkim.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.dmarc">
										<td><b>DMARC</b></td>
										<td>
											<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.dmarc.message ? curTPResults.resHead.dmarc.message : (curTPResults.resHead.from.isInternal ? 'DMARC is Internal' : 'No DMARC was sent.')}}</span>
										</td>
										<td>
											<i *ngIf="!curTPResults?.resHead?.dmarc?.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
											<i class="far" *ngIf="curTPResults?.resHead?.dmarc?.message" [ngClass]="curTPResults.resHead.dmarc.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.dmarc.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults.resHead.compauth">
										<td><b>CompAuth</b></td>
										<td>
											<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.compauth.message ? curTPResults.resHead.compauth.message : (curTPResults.resHead.from.isInternal ? 'CompAuth is Internal' : 'No CompAuth was sent.')}}</span>
										</td>
										<td>
											<i *ngIf="!curTPResults?.resHead?.compauth?.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
											<i class="far" *ngIf="curTPResults.resHead.compauth.message" [ngClass]="curTPResults.resHead.compauth.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.compauth.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
										</td>
									</tr>
									<tr *ngIf="curTPResults?.resHead?.from && curTPResults?.resHead?.from?.tls && (curTPResults?.resHead?.from?.tls?.message || curTPResults?.resHead?.from?.tls?.recipient?.message || curTPResults?.resHead?.from?.tls?.external?.message || curTPResults?.resHead?.from?.tls?.sender?.message)">
										<td>
											<span><b>TLS</b></span>
										</td>
										<td>
											<div class="flxClmn vSpace05">
												<span>{{curTPResults.resHead.from.tls.message}}</span>
												<span *ngIf="curTPResults?.resHead?.from?.tls?.recipient?.message">{{curTPResults.resHead.from.tls.recipient.message}}</span>
												<span *ngIf="curTPResults?.resHead?.from?.tls?.external?.message">{{curTPResults.resHead.from.tls.external.message}}</span>
												<span *ngIf="curTPResults?.resHead?.from?.tls?.sender?.message">{{curTPResults.resHead.from.tls.sender.message}}</span>
											</div>
										</td>
										<td>
											<div class="flxClmn" style="align-items: flex-start;">
												<i class="far" [ngClass]="curTPResults.resHead.from.tls.status === false ? 'fa-times-circle' : 'fa-check'"></i>
											</div>
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
							<span style="opacity: 0.5;">Loading</span>
						</div>
					</div>
					<div class="flxClmn ro18 co7 md-co12" style="min-height: 755px;"
						 [ngClass]="{'co12' : !planInfo?.allowReviewerShowContent}">
						<div class="threat-protection-card flxClmn" style="flex: 1 0;">
							<div class="card-header flxRow-between" style="align-items: center;">
									<span class="card-title" [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.urlStatus).color === 'darkred' ? 'darkred' : ''}">
										Links Analysis {{curTPResults?.resUrl?.list?.length ? '(' + curTPResults?.resUrl?.list?.length + ')' : ''}}
									</span>
								<div class="flxRow hSpace1" style="align-items: center;">
									<i class="far hvr-opacity" style="font-size: 1rem;" *ngIf="curTPResults?.resUrl && curTPResults.resUrl.status !== dic.CONSTANTS.threatProtection.status.safe && !curTPResults.resUrl.sub_status?.length"
									   tooltip="{{curTPResults.urlStatus}}"
									   [ngClass]="setInboundStatusStyles(curTPResults?.urlStatus).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults.urlStatus).icon"
									   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.urlStatus).color}">
									</i>
									<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 5px; margin: 0;"
										 *ngIf="curTPResults?.resUrl && (curTPResults.resUrl.status === dic.CONSTANTS.threatProtection.status.safe || curTPResults.resUrl.sub_status?.length)"
										 [ngClass]="setInboundStatusStyles(curTPResults?.resUrl?.status).color">
										 <div class="threat-tag-BG"></div>
										 <i class="far threat-tag-icon" [ngClass]="curTPResults.resUrl.status === dic.CONSTANTS.threatProtection.status.safe ? 'fa-check-circle' : setInboundStatusStyles(curTPResults?.resUrl?.status).icon"></i>
										 <span class="threat-tag-text">{{curTPResults.resUrl.status === dic.CONSTANTS.threatProtection.status.safe ? dic.CONSTANTS.threatProtection.status.safe : curTPResults.resUrl.sub_status}}</span>
									</div>
									<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
								</div>
							</div>
							<div class="flxClmn animated fadeIn" style="align-items: center; flex: 1 0; padding: 10px; overflow: auto;"
								 *ngIf="curTPResults"
								 [ngStyle]="{'justify-content' : !curTPResults?.resUrl?.list || !curTPResults?.resUrl?.list?.length ? 'center' : ''}">
								<div class="w100" style="flex: 1 0;" *ngIf="curTPResults?.resUrl?.list && curTPResults?.resUrl?.list?.length">
									<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
										<tr>
											<th style="padding: 0;"></th>
										</tr>
										<tr *ngFor="let url of curTPResults.resUrl.list">
											<td>
												<div class="flxClmn vSpace1 ellipsis" style="padding: 10px 0;">
													<div class="flxRow" style="align-items: center;">
														<div style="flex: 1 0; padding-right: 15px;" class="ellipsis flxRow hSpace05">
															<b style="flex-basis: 40px;">Name:</b>
															<span class="ellipsis" style="flex: 1 0;">{{url.name ? url.name : url.domain ? url.domain : url.url}}</span>
														</div>
														<div class="flxRow hSpace05" style="align-items: center;" (ngInit)="url.icon = setInboundStatusStyles(url.status).icon;">
															<div style="width: 13px; height: 13px;">
																<i class="hvr-opacity far fa-sync-alt" *ngIf="!url?.rescanLinkInProcess" style="cursor:pointer;"
																   (click)="openRescanLinkPopup(url)"
																   tooltip="Rescan Link"></i>
																<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 15px; animation-duration: 1s;" *ngIf="url?.rescanLinkInProcess"></i>
															</div>
															<i class="far" *ngIf="!url.category" [ngClass]="url.icon === 'fa-check-circle' ? 'fa-check' : url.icon === 'fa-bug' ? 'fa-times-circle' : url.icon"
															   [ngStyle]="{'color': setInboundStatusStyles(url.status).color}" placement="right" tooltip="{{url.status}}"></i>
															<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 5px; margin: 0;"
																 *ngIf="url.category"
																 [ngClass]="setInboundStatusStyles(url.status).color">
																 <div class="threat-tag-BG"></div>
																 <i class="far threat-tag-icon" [ngClass]="setInboundStatusStyles(url.status).icon"></i>
																 <span class="threat-tag-text">{{url.category}}</span>
															</div>
														</div>
													</div>
													<div class="flxRow hSpace05" style="align-items: flex-end;" *ngIf="url?.original_url || url.url">
														<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
															<b style="flex-basis: 40px;">URL:</b>
															<span class="ellipsis" style="flex: 1 0;">{{url.original_url || url.url}}</span>
														</div>
														<a (click)="previewLink(url.redirect_url || url.original_url || url.url)" style="text-align: right;">
															<i class="fas fa-eye" style="opacity: 0.7;" tooltip="Safe Preview"></i>
														</a>
														<a (click)="copyItemToClipboard(url.original_url || url.url);" style="text-align: right;">
															<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy URL"></i>
														</a>
														<sr-row-action *ngIf="reviewerInfo.is_security_reviewer" [targets]="[{label: dic.CONSTANTS.srRowAction.targetLabels.url, value: url.original_url || url.url}]" [allowPlan]="false" (apply)="doRowAction($event, 'links')"></sr-row-action>
													</div>
													<div class="flxRow hSpace05" style="align-items: flex-end;" *ngIf="url?.url && url?.redirect_url && (url?.original_url && url?.original_url !== url?.redirect_url || !url?.original_url && url?.url !== url?.redirect_url)">
														<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
															<b style="flex-basis: 40px;">Redirect:</b>
															<span class="ellipsis" style="flex: 1 0;" tooltip="{{url.redirect_url || url.url}}">{{url.redirect_url || url.url}}</span>
														</div>
														<a (click)="copyItemToClipboard(url.redirect_url || url.url);" style="text-align: right;">
															<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy redirect URL"></i>
														</a>
														<sr-row-action *ngIf="reviewerInfo.is_security_reviewer" [targets]="[{label: dic.CONSTANTS.srRowAction.targetLabels.redirectUrl, value: url.redirect_url || url.url}]" [allowPlan]="false" (apply)="doRowAction($event, 'links')"></sr-row-action>
													</div>
													<div class="flxRow" style="align-items: flex-end;" *ngIf="url?.malware_type">
														<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
															<b style="flex-basis: 40px;">Malware Type:</b>
															<span class="ellipsis" style="flex: 1 0;">{{url.malware_type}}</span>
														</div>
														<a (click)="copyItemToClipboard(url.malware_type);" style="text-align: right;">
															<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy malware type"></i>
														</a>
													</div>
													<div class="flxRow" style="align-items: flex-end;" *ngIf="url?.domain_age">
														<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
															<b style="flex-basis: 40px;">Domain Age:</b>
															<span class="ellipsis" style="flex: 1 0;">{{url.domain_age | date:'MM/dd/yyyy'}}</span>
														</div>
													</div>
													<div class="flxRow" style="align-items: flex-end;" *ngIf="planInfo?.urlTracking">
														<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
															<b style="flex-basis: 40px;">Tracking:</b>
															<a class="blue-link" style="flex: 1 0; text-decoration: underline; font-weight: 400;" *ngIf="url?.clickInfo?.devices && url?.clickInfo?.devices?.length"
															   (click)="openClickTrackingPopup(url)">
																{{'Clicked ' + url.clickInfo?.devices?.length + ' time' + (url?.clickInfo?.devices?.length > 1 ? 's' : '')}}
															</a>
															<span *ngIf="!url?.clickInfo?.devices || url?.clickInfo?.devices?.length === 0">
																	Was not clicked yet
																</span>
														</div>
													</div>
												</div>
											</td>
										</tr>
									</table>
								</div>
								<span *ngIf="!curTPResults?.resUrl?.list || !curTPResults?.resUrl?.list?.length">No links in email</span>
							</div>
							<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
								<span style="opacity: 0.5;">Loading</span>
							</div>
						</div>
						<div class="threat-protection-card flxClmn" style="flex: 1 0;">
							<div class="card-header flxRow-between" style="align-items: center;">
									<span class="card-title" [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.hashStatus).color === 'darkred' ? 'darkred' : ''}">
										Attachments Analysis {{curTPResults?.resHash?.list?.length ? '(' + curTPResults?.resHash?.list?.length + ')' : ''}}
									</span>
								<div class="flxRow hSpace1" style="align-items: center;">
									<i class="far hvr-opacity" style="font-size: 1rem;" *ngIf="curTPResults?.resHash && curTPResults.resHash.status !== dic.CONSTANTS.threatProtection.status.safe && !curTPResults.resHash.sub_status?.length"
									   tooltip="{{curTPResults.hashStatus}}"
									   [ngClass]="setInboundStatusStyles(curTPResults.hashStatus).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults.hashStatus).icon"
									   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults.hashStatus).color}">
									</i>
									<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 5px; margin: 0;"
										 *ngIf="curTPResults?.resHash && (curTPResults.resHash.status === dic.CONSTANTS.threatProtection.status.safe || curTPResults.resHash.sub_status?.length)"
										 [ngClass]="setInboundStatusStyles(curTPResults.resHash.status).color">
										 <div class="threat-tag-BG"></div>
										 <i class="far threat-tag-icon" [ngClass]="curTPResults.resHash.status === dic.CONSTANTS.threatProtection.status.safe ? 'fa-check-circle' : setInboundStatusStyles(curTPResults.resHash.status).icon"></i>
										 <span class="threat-tag-text">{{curTPResults.resHash.status === dic.CONSTANTS.threatProtection.status.safe ? dic.CONSTANTS.threatProtection.status.safe : curTPResults.resHash.sub_status}}</span>
									</div>
									<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
								</div>
							</div>
							<div class="flxClmn animated fadeIn" style="align-items: center; flex: 1 0; padding: 10px; overflow: auto;"
								 *ngIf="curTPResults"
								 [ngStyle]="{'justify-content' : !curTPResults?.resHash?.list || !curTPResults?.resHash?.list?.length ? 'center' : ''}">
								<div style="flex: 1 0;" *ngIf="curTPResults?.resHash?.list && curTPResults?.resHash?.list?.length">
									<table class="w100 simpleDataTable message-analysis-table middle" style="table-layout: fixed;">
										<tr>
											<th style="padding: 0;"></th>
										</tr>
										<tr *ngFor="let file of curTPResults.resHash.list">
											<td>
												<div class="flxClmn vSpace1" style="padding: 10px 0;">
													<div class="flxRow" style="align-items: center;">
															<span style="font-weight: 500; flex: 1 0; padding-right: 15px; word-break: break-all;">
																{{file.name}}
															</span>
														<div class="flxRow hSpace05" style="align-items: center;" (ngInit)="file.icon = setInboundStatusStyles(file.status).icon;">
															<div style="width: 13px; height: 13px;">
																<i class="hvr-opacity far fa-sync-alt" *ngIf="!file?.rescanFileInProcess" style="cursor:pointer;"
																   (click)="openRescanFilePopup(file)"
																   tooltip="Rescan File"></i>
																<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 15px; animation-duration: 1s;" *ngIf="file?.rescanFileInProcess"></i>
															</div>
															<a (click)="previewAttachmentFromEmail(curEmail, file)" style="text-align: right;" *ngIf="planInfo?.allowReviewerShowContent">
																<i class="fas fa-eye" style="opacity: 0.7;" tooltip="Preview"></i>
															</a>
															<i class="far" *ngIf="!file.category" [ngClass]="file.icon === 'fa-check-circle' ? 'fa-check' : file.icon === 'fa-bug' ? 'fa-times-circle' : file.icon"
															   [ngStyle]="{'color': setInboundStatusStyles(file.status).color}" placement="right" tooltip="{{file.status}}"></i>
															<div class="flxRow threat-tag not-clickable" style="align-items: center; gap: 5px; margin: 0;"
																 *ngIf="file.category"
																 [ngClass]="setInboundStatusStyles(file.status).color">
																 <div class="threat-tag-BG"></div>
																 <i class="far threat-tag-icon" [ngClass]="setInboundStatusStyles(file.status).icon"></i>
																 <span class="threat-tag-text">{{file.category}}</span>
															</div>
														</div>
													</div>
													<div class="flxRow" style="align-items: flex-end;">
															<span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" *ngIf="file.type">
																<b>Type</b>: {{file.type}}
															</span>
													</div>
													<div class="flxRow hSpace05" style="align-items: flex-end;">
															<span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" *ngIf="file.hash">
																<b>Hash</b>: {{file.hash}}
															</span>
														<a *ngIf="file.hash" (click)="copyItemToClipboard(file.hash);" style="text-align: right;">
															<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy file hash"></i>
														</a>
														<sr-row-action *ngIf="reviewerInfo.is_security_reviewer && file.hash" [targets]="[{label: dic.CONSTANTS.srRowAction.targetLabels.fileHash, value: file.hash, data: {name: file.name || 'attachment_no_name', hash: file.hash, type: file.type, contentType: file.contentType || file.type}}]" [allowPlan]="false" (apply)="doRowAction($event, 'attachments')"></sr-row-action>
													</div>
													<div class="flxRow" style="align-items: flex-end;" *ngIf="file?.malware_type">
															<span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" >
																<b>Malware Type</b>: <span tooltip="{{file.malware_type}}">{{file.malware_type}}</span>
															</span>
														<a (click)="copyItemToClipboard(file.malware_type);" style="text-align: right;">
															<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy malware type"></i>
														</a>
													</div>
												</div>
											</td>
										</tr>
									</table>
								</div>
								<span *ngIf="!curTPResults?.resHash?.list || !curTPResults?.resHash.list?.length">No attachments in email</span>
							</div>
							<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
								<span style="opacity: 0.5;">Loading</span>
							</div>
						</div>
					</div>
					<div class="email-content-card ro15 co10 md-co24" style="position: relative; margin: 0.75vw; min-height: 755px; max-height: 75vh;" *ngIf="planInfo?.allowReviewerShowContent"
						 [ngClass]="{'is-showing-content' : curEmail.isShowingContent || curEmail.content}">
						<div class="threat-protection-card flxClmn w100 h100" style="position: relative; z-index: 3; margin: 0;">
							<div class="card-header flxRow-between" style="align-items: center;">
									<span class="card-title">
										Email Content
									</span>
								<div class="flxRow hSpace1">
									<a [ngClass]="{'disabled' : !curEmail.content}">
										<i class="far fa-solid fa-code" style="font-size: 1rem;" tooltip="View source"
										   (click)="showHtml = !showHtml"></i>
									</a>
									<a [ngClass]="{'disabled' : !curEmail.content}">
										<i class="far fa-download" tooltip="Download email as EML" style="font-size: 1rem;"
										   (click)="downloadEml(curEmail)"></i>
									</a>
								</div>
							</div>
							<!--OpenAI action: save email to dataset-->
							<div class="flxRow animated fadeIn" style="align-items: center; flex-wrap: wrap; gap: 6px; padding: 7px 11px; border-bottom: 1px solid var(--ui-border);"
								 *ngIf="reviewerInfo.is_security_reviewer">
								<span style="font-size: 11.5px; font-weight: 600; letter-spacing: 0.4px; text-transform: uppercase; color: var(--ui-text-muted); margin-right: 4px;"
									  [tooltip]="dic.CONSTANTS.openAiDataset.titleTooltip">
									{{dic.CONSTANTS.openAiDataset.title}}
								</span>
								<ng-container *ngFor="let datasetClass of openAiDatasetClasses">
									<a class="flxRow hvr-opacity" style="align-items: center; gap: 5px; padding: 3px 10px; border-radius: 12px; font-size: 0.8rem; font-weight: 500; cursor: pointer;"
									   *ngIf="curEmail.openAiDatasetPending !== datasetClass.name"
									   [id]="'saveDataset' + datasetClass.name + 'Btn'"
									   [ngClass]="{'disabled' : curEmail.openAiDatasetInProcess}"
									   [ngStyle]="{'color': datasetClass.color, 'border': '1px solid ' + datasetClass.color, 'background': curEmail.openAiDatasetSaved?.includes(datasetClass.name) ? 'color-mix(in srgb, ' + datasetClass.color + ' 13%, transparent)' : 'transparent'}"
									   [tooltip]="(curEmail.openAiDatasetSaved?.includes(datasetClass.name) ? dic.CONSTANTS.openAiDataset.alreadySavedTooltip : dic.CONSTANTS.openAiDataset.saveTooltip) + datasetClass.name"
									   (click)="curEmail.openAiDatasetPending = datasetClass.name">
										<i class="far" style="font-size: 0.75rem;" [ngClass]="curEmail.openAiDatasetSaved?.includes(datasetClass.name) ? 'fa-check' : datasetClass.icon"></i>
										<span>{{datasetClass.name}}</span>
									</a>
									<div class="flxRow animated fadeIn" style="align-items: center; gap: 8px; padding: 3px 10px; border-radius: 12px; font-size: 0.8rem; font-weight: 500;"
										 *ngIf="curEmail.openAiDatasetPending === datasetClass.name"
										 [ngStyle]="{'color': datasetClass.color, 'border': '1px solid ' + datasetClass.color, 'background': 'color-mix(in srgb, ' + datasetClass.color + ' 13%, transparent)'}">
										<span>{{dic.CONSTANTS.openAiDataset.saveAs + datasetClass.name}}?</span>
										<i class="far fa-spinner fa-spin" style="font-size: 0.75rem;" *ngIf="curEmail.openAiDatasetInProcess"></i>
										<a class="hvr-opacity" style="cursor: pointer;" [tooltip]="dic.CONSTANTS.openAiDataset.approve" *ngIf="!curEmail.openAiDatasetInProcess"
										   [id]="'approveDataset' + datasetClass.name + 'Btn'"
										   (click)="saveEmailToOpenAiDataset(curEmail, datasetClass.name)">
											<i class="far fa-check-circle" style="font-size: 0.9rem;" [ngStyle]="{'color': datasetClass.color}"></i>
										</a>
										<a class="hvr-opacity" style="cursor: pointer;" [tooltip]="dic.CONSTANTS.openAiDataset.cancel" *ngIf="!curEmail.openAiDatasetInProcess"
										   (click)="curEmail.openAiDatasetPending = null">
											<i class="far fa-times-circle" style="font-size: 0.9rem; opacity: 0.45;" [ngStyle]="{'color': datasetClass.color}"></i>
										</a>
									</div>
								</ng-container>
								<a class="flxRow-center hvr-opacity" id="classifyEmailOpenAiBtn" style="align-items: center; width: 26px; height: 26px; border-radius: 50%; cursor: pointer; color: var(--ui-brand); border: 1px solid var(--ui-brand);"
								   [tooltip]="dic.CONSTANTS.openAiDataset.classifyTooltip"
								   (click)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.classifyEmail.display)">
									<i class="far fa-magic" style="font-size: 0.75rem;"></i>
								</a>
							</div>
							<div style="font-family: 'Roboto Condensed'; opacity: 0.8; align-items: center; letter-spacing: 0.4px; font-size: 0.75rem; background: #f6f6f6; padding: 10px 20px; border-top: none; border-bottom: solid 1px #d4d4d4; border-bottom-width: 3px;" class="flxRow hSpace1" *ngIf="!showHtml && curEmail.content">
								<i style="opacity: 0.75;" class="far fa-exclamation-circle"></i>
								<span>NOTE: Email content is not fully displayed here since some elements are missing from this view, like CSS and JS.</span>
							</div>
							<div *ngIf="curEmail.content" class="input-wrap flxClmn" style="flex: 1 0; overflow: auto; padding: 15px 20px 10px; background: #f9f9f9;">
								<div *ngIf="!showHtml" style="flex: 1 0; flex-direction: column;" [ngStyle]="{'display': showHtml ? 'none' : 'flex'}">
									<div id="quarantinedHtmlContainer" class="static-color" style="flex: 1 0; overflow: auto; background: white; padding: 0 10px;" *ngIf="curEmail.content.html">
										<div id="quarantinedHtmlContainerData" style="display: inline; white-space: normal; margin: 0 0 0 1em;"
											 [innerHTML]="curEmail.content.html">
										</div>
									</div>
									<div id="quarantinedAttachmentsContainer" *ngIf="curEmail?.content?.attachments?.length">
										<hr style="width: 80%; margin: 10px auto;"/>
										<div class="flxRow hSpace1" style="margin: 0;">
											<div class="flxRow" style="flex:1 0; max-height: 66px; flex-wrap: wrap; overflow: auto;">
												<attachment-c
													*ngFor="let file of curEmail.content.attachments"
													[attName]="file.name"
													[attSize]="file.size"
													(preview)="previewAttachment = file;"
													(download)="downloadAttachment(file.content, file.name, file.type)">
												</attachment-c>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="showHtml" class="flxClmn" style="flex: 1 0;">
									<pre>{{curEmail.content.html || curEmail.content.text}}</pre>
								</div>
							</div>
							<!--"show content" button for large size-->
							<div class="flxClmn-center" style="align-items: center; flex: 1 0; background: radial-gradient(transparent, #f5f8ff);"
								 [ngClass]="curEmail.loadingEmailContent && 'shinyFX'"
								 [ngStyle]="{'overflow' : curEmail.loadingEmailContent ? 'hidden' : 'auto'}"
								 *ngIf="!curEmail.content">
								<btn-c class="show-email-large-btn" style="z-index: 5;"
									   [isDisabled]="loadQuarantineData"
									   [loading]="curEmail.loadingEmailContent"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.review.display);">
									Show Content
								</btn-c>
							</div>
						</div>
						<!--label "show content" button for laptop size-->
						<a class="hSpace1 blueLink flxRow-center show-email-medium-btn"
						   style="padding: 10px; font-size: 0.9rem; font-weight: 500; align-items: center; position: relative; z-index: 5;"
						   *ngIf="!curEmail.isShowingContent && !curEmail.content"
						   [ngClass]="{'disabled': loadQuarantineData}"
						   (click)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.review.display)">
							<span>Show Email Content</span>
							<i class="far fa-chevron-down animated flash infinite" style="font-size: 0.6rem; margin-top: 0; animation-duration: 2.5s;"></i>
						</a>
					</div>
					<div class="threat-protection-card flxClmn ro15 co12 md-co24" style="min-height: min(400px,47vh);">
						<div class="card-header flxRow-between" style="align-items: center; height: 45px; padding: 7px 11px;">
								<span class="card-title">
									Headers
								</span>
							<div class="d-flex flex-row hSpace1" style="align-items: center; align-self: stretch;">
								<!--search-->
								<search-box [(model)]="headerSearchTerm"
											(modelChange)="searchHeader()"
											[isDisabled]="!(curEmail?.headers?.length)"
											placeholder="Find in results">
								</search-box>
								<a (click)="copyAllHeaders();" [ngClass]="{'disabled': !curEmail?.headers?.length}"
								   [ngStyle]="!curEmail?.headers?.length && {'opacity' : '0.5'}">
									<i class="far fa-copy" tooltip="Copy all headers" style="font-size: 1rem;"></i>
								</a>
								<a (click)="exportHeadersText();" [ngClass]="{'disabled': !curEmail?.headers?.length}"
								   [ngStyle]="!curEmail?.headers?.length && {'opacity' : '0.5'}">
									<i class="far fa-download" tooltip="Download headers" style="font-size: 1rem;"></i>
								</a>
							</div>
						</div>
						<!--headers table-->
						<div class="flxClmn" style=" flex: 1 0; overflow: auto;">
							<div class="flxClmn" style="flex: 1 0; padding: 0 15px 10px;" *ngIf="curEmail?.headers?.length">
								<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed; white-space: normal; word-break: break-word;">
									<tr>
										<th style="width: 215px;"></th>
										<th></th>
									</tr>
									<tr *ngFor="let headerObj of curEmail.headers" [hidden]="headerObj.hide">
										<td class="hvr-opacity" style="cursor: pointer;" tooltip="Click to copy" (click)="copyItemToClipboard(headerObj.name || headerObj.key)"><b>{{headerObj.name || headerObj.key}}</b></td>
										<td class="hvr-opacity" style="cursor: pointer;" tooltip="Click to copy" (click)="copyItemToClipboard(headerObj.value)">
											<span>{{headerObj.value}}</span>
										</td>
									</tr>
								</table>
							</div>
							<div class="flxClmn-center" style="align-items: center; flex: 1 0; background: radial-gradient(transparent, #f5f8ff);"
								 *ngIf="!curEmail?.headers?.length"
								 [ngClass]="curEmail.loadingHeaders && 'shinyFX'"
								 [ngStyle]="{'overflow' : curEmail.loadingHeaders ? 'hidden' : 'auto'}">
								<btn-c style="z-index: 5;"
									   [loading]="curEmail.loadingHeaders"
									   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.headers.display)">
									Get headers
								</btn-c>
							</div>
						</div>
					</div>
					<div class="threat-protection-card flxClmn ro15 co12 md-co24" style="min-height: 350px;">
						<div class="card-header flxRow-between" style="align-items: center; height: 45px; padding: 7px 11px; justify-content: space-between;">
								<span class="card-title">
									Reviewers Activity {{curEmail?.reviewer_actions?.length ? '(' + curEmail?.reviewer_actions?.length + ')' : ''}}
								</span>
							<search-box [(model)]="reviewerSearchTerm"
										(modelChange)="searchReviewer()"
										[isDisabled]="!(curEmail?.reviewer_actions?.length)"
										placeholder="Find in results">
							</search-box>
						</div>
						<div class="flxClmn" style="flex: 1 0; align-items: center; padding: 15px; overflow: auto;"
							 [ngStyle]="{'justify-content' : !curEmail?.reviewer_actions || !curEmail?.reviewer_actions?.length ? 'center' : ''}">
							<table style="text-align: left; width:100%; table-layout: fixed;" class="simpleDataTable" *ngIf="curEmail?.reviewer_actions && curEmail?.reviewer_actions?.length">
								<tr>
									<th style="width: 20%;">Created</th>
									<th style="width: 25%;">Reviewer</th>
									<th style="width: 50%;">Action</th>
								</tr>
								<tr *ngFor="let actionObj of curEmail.reviewer_actions | orderBy: '-created'" [hidden]="actionObj.hide">
									<td >
										{{actionObj.created | date:'MM/dd/yyyy HH:mm'}}
									</td>
									<td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
										{{actionObj.reviewer}}
									</td>
									<td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
										<span style="display: block; width: fit-content; max-width: 100%;" tooltip="{{actionObj.action}}">{{actionObj.action}}</span>
									</td>
								</tr>
							</table>
							<span style="opacity: 0.7;" *ngIf="!curEmail?.reviewer_actions || !curEmail?.reviewer_actions?.length">
									No activity by reviewers
								</span>
						</div>
					</div>

					<div class="threat-protection-card flxClmn ro15 co12 md-co24" style="min-height: 350px;" *ngIf="curEmail?.showEmailTraceSection">
						<div class="card-header flxRow-between" style="align-items: center; height: 45px; padding: 7px 11px; justify-content: space-between;">
							<span class="card-title">
								Email Trace
							</span>
						</div>
						<div class="flxClmn" style="flex: 1 0; align-items: center; padding: 15px; overflow: auto;"
							 [ngStyle]="{'justify-content' : !curEmail?.emailTraceLogs?.length ? 'center' : ''}">
							<div class="flxClmn vSpace2 w100" *ngIf="curEmail?.emailTraceLogs?.length">
								<div class="flxClmn bs-enabled vSpace05 w100" *ngFor="let traceObj of curEmail.emailTraceLogs">
									<div class="flex-row gap-1" *ngFor="let message of traceObj.text">
										<span class="flex-shrink-0" *ngIf="message.timestamp"><b>{{message.timestamp | date:'MM/dd/yyyy HH:mm:ss'}}</b>:</span>
										<span *ngIf="message.log" style="white-space: normal;">&nbsp;{{message.log}}</span>
									</div>
								</div>
							</div>
							<loader height="35" width="35" style="opacity: 0.8;" *ngIf="curEmail?.loadingEmailTrace"></loader>
							<span style="opacity: 0.7;" *ngIf="curEmail?.emailTraceLoaded && !curEmail?.emailTraceLogs?.length">
								No email trace found
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<!--OpenAI Classify Email popup-->
<popup-c class="overflownV bs-enabled" *ngIf="openAiClassifyEmailPopup?.show"
		 head="Scan Email with OpenAI" size="dynamic"
		 (closeCb)="openAiClassifyEmailPopup.show = false; actionFinished();"
		 (confirmCb)="openAiClassifyEmailPopupExecute();"
		 [buttons]="{confirm: {text: 'Rescan', loading: openAiClassifyEmailPopup.actionInProcess}}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="embedded" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('embeddedNew')" [checked]="openAiClassifyEmailPopup.embeddedNew" value="embeddedNew"/>
			<label for="embedded" style="line-height: 30px;">Scan with Embedded Model - Experimental</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Embedding model - Experimental version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="finetune" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('finetuneNew')" [checked]="openAiClassifyEmailPopup.finetuneNew" value="finetuneNew"/>
			<label for="finetune" style="line-height: 30px;">Scan with Fine-Tuned Model - Experimental</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Fine-Tuned model - Experimental version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="baseline" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('baselineNew')" [checked]="openAiClassifyEmailPopup.baselineNew" value="baselineNew"/>
			<label for="baseline" style="line-height: 30px;">Scan with untrained GPT Model - Experimental</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run untrained GPT model - Experimental version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="hybrid" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('hybridNew')" [checked]="openAiClassifyEmailPopup.hybridNew" value="hybridNew"/>
			<label for="hybrid" style="line-height: 30px;">Scan with Hybrid Cluster - Experimental</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Hybrid cluster - Experimental version" placement="bottom"></i>
		</div>
		<hr/>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="embedded2" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('embeddedProd')" [checked]="openAiClassifyEmailPopup.embeddedProd" value="embeddedProd"/>
			<label for="embedded2" style="line-height: 30px;">Scan with Embedded Model - Production</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Embedding model - Production version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="finetune2" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('finetuneProd')" [checked]="openAiClassifyEmailPopup.finetuneProd" value="finetuneProd"/>
			<label for="finetune2" style="line-height: 30px;">Scan with Fine-Tuned Model - Production</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Fine-Tuned model - Production version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="baseline2" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('baselineProd')" [checked]="openAiClassifyEmailPopup.baselineProd" value="baselineProd"/>
			<label for="baseline2" style="line-height: 30px;">Scan with untrained GPT Model - Production</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run untrained GPT model - Production version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="hybrid2" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('hybridProd')" [checked]="openAiClassifyEmailPopup.hybridProd" value="hybridProd"/>
			<label for="hybrid2" style="line-height: 30px;">Scan with Hybrid Cluster - Production</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Hybrid cluster - Production version" placement="bottom"></i>
		</div>
		<div class="gap-1" style="display: flex;margin: 2px;">
			<input id="fallback2" type="radio" name="group1" (change)="setModelOpenAiClassifyEmailPopup('fallbackProd')" [checked]="openAiClassifyEmailPopup.fallbackProd" value="fallbackProd"/>
			<label for="fallback2" style="line-height: 30px;">Scan with Fallback Model - Production</label>
			<i style="font-weight: 400; margin-left: 5px;" class="far fa-question-circle" tooltip="Run Fallback model - Production version" placement="bottom"></i>
		</div>

		<div *ngIf="openAiClassifyEmailPopup.results">
			<b>Scan Results: </b>
			<span>{{openAiClassifyEmailPopup.results}}</span>
		</div>
		<div *ngIf="openAiClassifyEmailPopup.results && (openAiClassifyEmailPopup.embeddedNew || openAiClassifyEmailPopup.embeddedProd)">
			<b>Description:</b><br/>
			<ul style="padding-left: 10px;">
				<li>The first number for each class is the score (the bigger is better), how it is used by the classification flow.</li>
				<li>The number in the parentheses is the raw distance to that class (the smaller is better). </li>
				<li>The smallest distance should not necessary lead to the largest score because we calculate scores based on the 10 closest points, and the class areas are highly overlapped.</li>
				<li>If the distance to some class is lower than 0.1 this is the sign that this email is duplicated with another email, already contained in the database.</li>
			</ul>
		</div>
	</div>
</popup-c>

<!--Authenticate Sender popup-->
<popup-c class="overflownV" *ngIf="showAuthSenderPopup"
		 head="Authenticate Sender" size="dynamic"
		 (closeCb)="showAuthSenderPopup = false; actionFinished();"
		 (confirmCb)="authenticateSender();"
		 [buttons]="{
					 cancel: blockSenderAuthRequest ? 'OK' : 'Cancel' ,
					 confirm: {text: 'Authenticate', disabled: authSenderInProcess || (senderAuthMethod === dic.CONSTANTS.authenticateSenderMethods.phone && !senderAuthPhone.phone_number),
							   loading: authSenderInProcess, hide: blockSenderAuthRequest}
					 }">
	<div class="flxClmn f-1-0" style="overflow: visible;">
		<div style="margin-bottom: 20px; font-size: 15px; line-height: 23px;"
			 *ngIf="curEmail.auth_sender && curEmail.auth_sender.updated"
			 [ngStyle]="!blockSenderAuthRequest && {'border-bottom': '1px solid #ccc'}">
			<div *ngIf="curEmail.auth_sender.method === dic.CONSTANTS.authenticateSenderMethods.phone">Your last sender authentication request was sent to: +{{curEmail.auth_sender.phone.country_code}}-{{curEmail.auth_sender.phone.phone_number}}</div>
			<div *ngIf="curEmail.auth_sender.method === dic.CONSTANTS.authenticateSenderMethods.email">Your last sender authentication request was sent to: {{curEmail.sender}}</div>
			<div *ngIf="curEmail.auth_sender.status">Sender has {{curEmail.auth_sender.status === 'request' ? 'not yet responded to' : curEmail.auth_sender.status === 'approve' ? 'approved': 'denied'}} the authentication request</div>
			<div *ngIf="blockSenderAuthRequest">You can send a new request in {{dic.CONSTANTS.authSenderTtl - curEmail.auth_sender.minutes}} minutes</div>
		</div>
		<div *ngIf="!blockSenderAuthRequest">
			<div style="font-size: 16px;">
				Are you sure you want to verify the sender's identity?
				<i class="far fa-question-circle" style="cursor: pointer; margin-right:3px;"
				   tooltip="Sender will be asked to review the content of the sent email and either confirm or deny sending this email"></i>
			</div>
			<div style="margin-left: 20px; line-height: 27px;">
				<div>Sender will receive a message to confirm their identity:</div>
				<div class="input-group">
					<label class="radio-container" for="senderAuthMethodSMS" style="margin-bottom: 0;">
						<input type="radio" id="senderAuthMethodSMS" name="senderAuthMethod"
							   value="phone"
							   [(ngModel)]="senderAuthMethod">
						<span class="checkmark" style="top: 5px;"></span>
						<span>Via <b>SMS</b> (preferred)</span>
					</label>
					<div class="flxRow" style="line-height: initial;" [ngClass]="{'disabled-overlay' : senderAuthMethod !== dic.CONSTANTS.authenticateSenderMethods.phone}">
						<country-code-select [(model)]="senderAuthPhone.country_code" ></country-code-select>
						<input id="phone"
							   [(ngModel)]="senderAuthPhone.phone_number"
							   type="tel" placeholder="Phone number"
							   style="width: 120px; padding-right: 20px; margin: 0; margin-left: 2px;"
							   pattern="/^[0-9]*$/"
							   maxlength="11"
							   [value]="senderAuthPhone.phone_number">
					</div>
					<label class="radio-container ellipsis" for="senderAuthMethodEmail" style="margin-bottom: 0;">
						<input type="radio" id="senderAuthMethodEmail" name="senderAuthMethod"
							   value="email" style="height: 0;"
							   [(ngModel)]="senderAuthMethod">
						<span class="checkmark" style="top: 5px;"></span>
						<span class="ellipsis">Via <b>Email</b> {{curEmail.sender}}</span>
					</label>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<!--Set Email Category popup-->
<popup-c class="overflownV" *ngIf="setCategoryPopup?.show"
		 head="Set Email Category" size="small"
		 subTitle="Update the email's category"
		 (closeCb)="setCategoryPopup = null; actionFinished();"
		 (confirmCb)="setCategoryConfirm();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: setCategoryPopup.setCategoryInProcess}}">
	<div class="flxClmn vSpace2 f-1-0" style="overflow: visible;">
		<div class="flxRow" style="align-items: center;">
			<div style="flex-basis: 70px;">Category:</div>
			<app-dropdown-c style="width: 250px;" text="{{setCategoryPopup.newCategory}}">
				<li *ngFor="let category of dic.CONSTANTS.quarantinedCategories"
					(click)="setCategoryPopup.newCategory = category;"
					id="{{category}}">
					{{category}}
				</li>
			</app-dropdown-c>
		</div>
		<div class="flxRow">
			<div style="flex-basis: 70px; line-height: 30px;">Reason:</div>
			<input type="text"
				   style="width: 250px;"
				   maxlength="100"
				   placeholder="Reason (optional)"
				   [(ngModel)]="setCategoryPopup.reason" />
		</div>

		<div class="flxRow-start hSpace1" style="align-items: center;">
			<checkbox id="reportTrustifi"
					  tooltipTxt="Our dedicated security team review each report daily and takes necessary actions to adjust our security features accordingly.
									 <br/>Based on feedback, our team can adjust the AI, add malicious senders to the global blacklist, enhance our security metrics and more."
					  tooltipDirection="right"
					  [(model)]="setCategoryPopup.reportToTrustifi">
				Report to Trustifi
			</checkbox>
			<span style="font-family: 'Roboto Condensed', sans-serif; color: cadetblue;">Recommended</span>
		</div>


		<div class="flxRow-start hSpace1" style="align-items: center;" *ngIf="!['Safe', 'External'].includes(setCategoryPopup.newCategory)">
			<checkbox id="blocklistSenderIdentity"
					  tooltipTxt="The sender's identity will be added to the blocklist, ensuring no further messages are received."
					  tooltipDirection="right"
					  [(model)]="setCategoryPopup.blocklistSenderIdentity">
				Blocklist Sender Identity
			</checkbox>
			<span style="font-family: 'Roboto Condensed', sans-serif; color: darkred;">{{setCategoryPopup.email?.sender}}</span>
		</div>

	</div>
</popup-c>

<!--URL tracking popup-->
<popup-c *ngIf="urlTrackingPopup?.show"
		 head="URL Click Tracking" size="medium"
		 subTitle="See how many times this recipient has clicked on the URL, and which location and device was used when clicking it"
		 (closeCb)="urlTrackingPopup = null; actionFinished();"
		 [buttons]="{cancel: 'OK'}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: auto;">
		<span class="ellipsis"><b>URL:</b> {{urlTrackingPopup.urlAddress}}</span>
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="urlTrackingPopup.clickInfo.devices"
			[headers]="[
						{text: 'Click Time', sortKey: 'created', width: '150px'},
						{text: 'Device'},
						{text: 'Location'},
					]"
			[cellsPrototype]="[
						{textKey: 'created', textType: 'dateAndTime'},
						{html: 'deviceCell'},
						{html: 'locationCell'},
					]"
			[scopeInstances]="[{openLocation: openLocation}]"
			[options]="{
						itemsNameSingular: 'click incident',
						defaultSortKey: '-created',
					}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--device cells-->
				<div *ngIf="cellId === 'deviceCell'">
						<span tooltip="{{item.agent && item.agent.browser ? item.agent.browser.name + ' (' + item.agent.browser.version + '), ' + item.agent.os.name + ' (' + item.agent.os.version + ')' : (item.agent.raw.ua || 'N/A')}}">
							<span *ngIf="item.agent && item.agent.browser" tooltip="{{item.agent.raw.ua}}">
								{{item.agent.browser.name + ' (' + item.agent.browser.version + '), ' + item.agent.os.name + ' (' + item.agent.os.version + ')'}}
							</span>
							<span *ngIf="item.agent && item.agent.raw && !item.agent.browser">{{item.agent.raw.ua || 'N/A'}}</span>
						</span>
				</div>
				<!--location cells-->
				<div *ngIf="cellId === 'locationCell'">
						<span>
							<span *ngIf="item.location && item.location">{{item.location.country}}{{item.location.city ? (', ' + item.location.city) : ''}}</span>
							<img style="cursor: pointer;" *ngIf="item.location && item.location.ll" (click)="openLocation(item.location.ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
						</span>
				</div>
			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

<!--Allowlist sender-->
<popup-c class="overflownV bs-enabled" *ngIf="allowlistSenderPopup?.show"
		 head="Add Sender to Allowlist" size="dynamic"
		 subTitle="Allowlisted emails will be automatically released to the recipient's inbox"
		 (closeCb)="allowlistSenderPopup = null; actionFinished();"
		 (confirmCb)="addSenderWhiteListPopupExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add', loading: actionInProcess}}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
		<span *ngIf="allowlistSenderPopup.email.status === 'quarantined'">Email {{allowlistSenderPopup.email.subject}} will be released from quarantine</span>

		<div class="d-flex align-items-center gap-4" *ngIf="planInfo?.allowGlobalAllowBlockLists">
			<div>Apply to:</div>
			<div class="d-flex align-items-center gap-2">
				<div class="checkbox-button radio-style"
					 (click)="allowlistSenderPopup.actionScope = 'global'"
					 [ngClass]="{'selected' : allowlistSenderPopup.actionScope === 'global'}">
					<label class="radio-container" for="scopeGlobalPlan" style="margin-bottom: 0;">
						Global list
						<input type="radio" id="scopeGlobalPlan" name="actionScope"
							   value="global"
							   [checked]="allowlistSenderPopup.actionScope === 'global'"
							   [(ngModel)]="allowlistSenderPopup.actionScope">
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="checkbox-button radio-style"
					 (click)="allowlistSenderPopup.actionScope = 'mailbox'"
					 [ngClass]="{'selected' : allowlistSenderPopup.actionScope === 'mailbox'}">
					<label class="radio-container" for="scopeMailboxPlan" style="margin-bottom: 0;">
						Personal list
						<input type="radio" id="scopeMailboxPlan" name="actionScope"
							   value="mailbox" [checked]="allowlistSenderPopup.actionScope === 'mailbox'"
							   [(ngModel)]="allowlistSenderPopup.actionScope">
						<span class="checkmark" ></span>
					</label>
				</div>
			</div>
		</div>
		<hr *ngIf="planInfo?.allowGlobalAllowBlockLists"/>
		<div class="d-flex gap-2 flex-column">
			<span>Choose specific items to add to allowlist:</span>
			<div class="d-flex flex-column gap-1">
				<div class="flxRow-start hSpace1 animated fadeIn" style="padding: 0; align-items: center;" *ngFor="let input of allowlistSenderPopup.items; let $index=index;">
					<checkbox id="allowListItem{{$index}}" [(model)]="input.model">
						{{input.text}}
					</checkbox>
					<i class="far fa-exclamation" style="color: red; margin-left: 3px; font-size: 0.5rem; border: solid 1px red; border-radius: 50%; width: 14px; height: 14px; display: flex; justify-content: center; align-items: center;"
					   *ngIf="input.warning"
					   tooltip="{{input.warning}}"></i>
				</div>

			</div>
		</div>
		<div class="flxRow">
			<div style="flex-basis: 70px; line-height: 30px;">Reason:</div>
			<input type="text"
				   style="width: 250px;"
				   maxlength="100"
				   placeholder="Reason (optional)"
				   [(ngModel)]="allowlistSenderPopup.reason" />
		</div>
	</div>
</popup-c>

<!--Blocklist sender-->
<popup-c class="overflownV bs-enabled" *ngIf="blocklistSenderPopup?.show"
		 head="Add Sender to Blocklist" size="dynamic"
		 subTitle="Blocklisted emails will be automatically quarantined"
		 (closeCb)="blocklistSenderPopup = null; actionFinished();"
		 (confirmCb)="blocklistSenderPopup.emails ? addBulkSenderBlacklistPopupExecute() : addSenderBlacklistPopupExecute();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add', loading: actionInProcess}}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">

		<div *ngIf="planInfo?.allowGlobalAllowBlockLists" class="d-flex align-items-center gap-4">
			<div>Apply to:</div>
			<div class="d-flex align-items-center gap-2">
				<div class="checkbox-button radio-style"
					 (click)="blocklistSenderPopup.actionScope = 'global'"
					 [ngClass]="{'selected' : blocklistSenderPopup.actionScope === 'global'}">
					<label class="radio-container" for="scopeGlobalPlan2" >
						Global list
						<input type="radio" id="scopeGlobalPlan2" name="actionScope"
							   value="global"
							   [(ngModel)]="blocklistSenderPopup.actionScope"
							   [checked]="blocklistSenderPopup.actionScope === 'global'">
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="checkbox-button radio-style"
					 (click)="blocklistSenderPopup.actionScope = 'mailbox'"
					 [ngClass]="{'selected' : blocklistSenderPopup.actionScope === 'mailbox'}">
					<label class="radio-container" for="scopeMailboxPlan2" >
						Personal list
						<input type="radio" id="scopeMailboxPlan2" name="actionScope"
							   value="mailbox"
							   [(ngModel)]="blocklistSenderPopup.actionScope"
							   [checked]="blocklistSenderPopup.actionScope === 'mailbox'">
						<span class="checkmark"></span>
					</label>
				</div>
			</div>
		</div>
		<hr *ngIf="planInfo?.allowGlobalAllowBlockLists"/>
		<div class="d-flex gap-2 flex-column" *ngIf="!blocklistSenderPopup.emails">
			<span>Choose specific items to add to blocklist:</span>
			<div class="d-flex flex-column gap-1">
				<div class="flxRow-start hSpace1 animated fadeIn" style="padding: 0; align-items: center;"
					 *ngFor="let input of blocklistSenderPopup.items; let $index = index;">
					<checkbox id="allowListItem2{{$index}}" [(model)]="input.model">
						{{input.text}}
					</checkbox>
					<i class="far fa-exclamation" style="color: red; margin-left: 3px; font-size: 0.5rem; border: solid 1px red; border-radius: 50%; width: 14px; height: 14px; display: flex; justify-content: center; align-items: center;"
					   *ngIf="input.warning"
					   tooltip="{{input.warning}}"></i>
				</div>
			</div>
		</div>
		<div class="flxRow">
			<div style="flex-basis: 70px; line-height: 30px;">Reason:</div>
			<input type="text"
				   style="width: 250px;"
				   maxlength="100"
				   placeholder="Reason (optional)"
				   [(ngModel)]="blocklistSenderPopup.reason" />
		</div>
	</div>
</popup-c>

<popup-c class="overflownV bs-enabled" *ngIf="allowlistLinksPopup?.show"
		 head="Add Links to Blocklist" size="dynamic"
		 subTitle="Blocklisted links will be automatically quarantined"
		 (closeCb)="allowlistLinksPopup = null; actionFinished();"
		 (confirmCb)="allowlistLinksPopup.doneCb();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add', loading: actionInProcess}}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
		<span>All non-safe links contained in this email will now be considered safe</span>
		<div *ngIf="planInfo?.allowGlobalAllowBlockLists" class="d-flex align-items-center gap-4">
			<div>Apply to:</div>
			<div class="d-flex align-items-center gap-2">
				<div class="checkbox-button radio-style"
					 (click)="allowlistLinksPopup.actionScope = 'global'"
					 [ngClass]="{'selected' : allowlistLinksPopup.actionScope === 'global'}">
					<label class="radio-container" for="scopeGlobalPlan2" >
						Global list
						<input type="radio" id="scopeGlobalPlan2" name="actionScope"
							   value="global"
							   [(ngModel)]="allowlistLinksPopup.actionScope"
							   [checked]="allowlistLinksPopup.actionScope === 'global'">
						<span class="checkmark"></span>
					</label>
				</div>
				<div class="checkbox-button radio-style"
					 (click)="allowlistLinksPopup.actionScope = 'mailbox'"
					 [ngClass]="{'selected' : allowlistLinksPopup.actionScope === 'mailbox'}">
					<label class="radio-container" for="scopeMailboxPlan2" >
						Personal list
						<input type="radio" id="scopeMailboxPlan2" name="actionScope"
							   value="mailbox"
							   [(ngModel)]="allowlistLinksPopup.actionScope"
							   [checked]="allowlistLinksPopup.actionScope === 'mailbox'">
						<span class="checkmark"></span>
					</label>
				</div>
			</div>
		</div>

	</div>
</popup-c>

<!--Reject Release Request-->
<popup-c class="bs-enabled" *ngIf="releaseRejectPopup?.show"
		 head="Reject Release Request" size="dynamic"
		 (closeCb)="releaseRejectPopup.show = false; actionFinished();"
		 (confirmCb)="releaseRejectPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: releaseRejectPopup.applyInProcess }}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<p>An email will be sent to the recipient stating that the requested email cannot be released</p>

		<div class="align-items-center flex-row gap-3">
			<div>Reviewer comments</div>
			<input type="text" placeholder="(Optional)"
				   style="width:330px;"
				   [(ngModel)]="releaseRejectPopup.securityTeamComments"/>
		</div>
	</div>
</popup-c>

<!--Release Request-->
<popup-c class="bs-enabled" *ngIf="requestReleasePopup?.show"
		 head="Request release of quarantined email" size="dynamic"
		 (closeCb)="requestReleasePopup = null; actionFinished();"
		 (confirmCb)="requestReleasePopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: requestReleasePopup.applyInProcess }}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<p>You are about to send a request to release this email from quarantine</p>

		<div class="align-items-center flex-row gap-3">
			<div>Release reason:</div>
			<input type="text"
				   style="width:330px;"
				   [(ngModel)]="requestReleasePopup.reason"/>
		</div>
	</div>
</popup-c>

<!--Release Quarantined Email-->
<popup-c class="bs-enabled" *ngIf="releaseQuarantinedEmailPopup?.show"
		 head="Release Quarantined Email" size="dynamic"
		 (closeCb)="releaseQuarantinedEmailPopup.show = false; actionFinished();"
		 (confirmCb)="releaseQuarantinedEmailPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Release', disabled: releaseQuarantinedEmailPopup.applyInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<p style="font-size: 14px;">{{releaseQuarantinedEmailPopup?.subTitle}}</p>

		<div *ngFor="let toggle of releaseQuarantinedEmailPopup?.releaseOptionsToggles; let index = index;">
			<div class="flex-row align-items-center gap-2">
				<checkbox id="checkbox-{{index}}"
						  [tooltipTxt]="toggle.tooltip"
						  [(model)]="toggle.model">
					{{toggle.labelName}}
				</checkbox>

				<input *ngIf="toggle.showInput" type="text" placeholder="description"
					   [disabled]="!toggle.model"
					   style="width:200px;"
					   [(ngModel)]="toggle.inputModel"/>
			</div>
		</div>
	</div>
</popup-c>

<!--Create Incident popup-->
<popup-c class="bs-enabled" *ngIf="incidentPopup?.show"
		 head="Create Incident" size="dynamic"
		 (closeCb)="incidentPopup.show = false; actionFinished();"
		 (confirmCb)="incidentPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: incidentPopup.applyInProcess || !incidentPopup.securityTeamComments.length}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<p style="font-size: 14px;">An email will be sent to all reviewers with details about this quarantined email. You can add your questions to the reviewers below.</p>

		<div class="d-flex flex-column gap-1">
			<div style="white-space: nowrap;">Security team comments</div>
			<textarea type="text" placeholder="Information needed from reviewers"
					  style="max-height: 100px;" rows="2" [required]="true" [(ngModel)]="incidentPopup.securityTeamComments">
			   </textarea>
			<div class="d-flex gap-2">
				<btn-c class="popup-action-btn bs-enabled"
					   startIcon="fa fa-magic"
					   [loading]="incidentPopup.generateInProcess"
					   [isDisabled]="incidentPopup.generateInProcess"
					   (action)="generateIncidentNote();">
					Improve Comment
				</btn-c>
			</div>
			<br/>
			<checkbox id="addUserNotification"
					  [(model)]="incidentPopup.addUserNotification">
				Add user notification
			</checkbox>
		</div>
	</div>

</popup-c>

<!--Security Reviewer Activity popup-->
<popup-c class="bs-enabled overflownV" *ngIf="securityReviewerPopup?.show"
		 head="Add Security Reviewer Activity" size="dynamic"
		 (closeCb)="securityReviewerPopup.show = false; actionFinished();"
		 (confirmCb)="securityReviewerPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add'}}">
	<div class="flex-column f-1-0 gap-2">
		<p style="font-size: 14px;">The activity will be shown in the generated report.</p>

		<div class="align-items-center flex-row gap-3">
			<div style="white-space: nowrap; min-width: 43px;">Activity</div>
			<textarea type="text" placeholder="Activity information"
					  style="width:330px; max-height: 68px;" rows="2" [required]="true"
					  [(ngModel)]="securityReviewerPopup.securityTeamCommentInput"></textarea>

		</div>
		<div class="align-items-center flex-row gap-3">
			<div style="white-space: nowrap; min-width: 43px;">Type</div>
			<app-dropdown-c style="width:330px;" text="{{securityReviewerPopup.emdrActionInput.model}}">
				<ul style="overflow: auto; max-height: 330px;">
					<li *ngFor="let dropdownItem of securityReviewerPopup.dropdownObjects"
						(click)="securityReviewerPopup.emdrActionInput.model = dropdownItem.name; securityReviewerPopup.emdrActionInput.selected = dropdownItem.selected">
						{{dropdownItem.name}}
					</li>
				</ul>
			</app-dropdown-c>
		</div>
		<checkbox id="addUserNotification"
				  [(model)]="securityReviewerPopup.addUserNotification">
			Add user notification
		</checkbox>
	</div>

</popup-c>

<!--Remove quarantined popup-->
<popup-c class="bs-enabled" *ngIf="removeQuarantinedPopup?.show"
		 [head]="removeQuarantinedPopup.title" size="dynamic"
		 (closeCb)="removeQuarantinedPopup.show = false; actionFinished();"
		 (confirmCb)="removeQuarantinedPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Remove', disabled: removeQuarantinedPopup.applyInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			{{removeQuarantinedPopup?.subTitle}}
		</div>
		<ul>
			<li>{{removeQuarantinedPopup.body}}</li>
		</ul>
		<div *ngFor="let toggle of removeQuarantinedPopup?.removeOptionsToggles; let index = index;">
			<div class="flex-row align-items-center gap-2">
				<checkbox id="checkbox-{{index}}"
						  [tooltipTxt]="toggle.tooltip"
						  [(model)]="toggle.model">
					{{toggle.labelName}}
				</checkbox>

				<input *ngIf="toggle.showInput" type="text" placeholder="description"
					   [disabled]="!toggle.model"
					   style="width:200px;"
					   [(ngModel)]="toggle.inputModel"/>
			</div>
		</div>
	</div>

</popup-c>

<!--CC: mailbox role popup - taken from inbound-mailboxes.component.html -> Job Title setting-->
<popup-c class="overflownV bs-enabled" *ngIf="mailboxRolePopup?.show"
		 head="Mailbox Role" size="dynamic"
		 subTitle="Set the job title for {{mailboxRolePopup.email}}"
		 (closeCb)="mailboxRolePopup.show = false;"
		 (confirmCb)="updateMailboxRole();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Save', loading: mailboxRolePopup.inProcess, disabled: !mailboxRolePopup.name}}">
	<div class="flex-column gap-3 f-1-0" style="overflow: visible;">
		<div class="flex-column gap-2">
			<span class="fw-bold">Job Title</span>
			<input type="text" placeholder="Job" style="width: 320px;"
				   [(ngModel)]="mailboxRolePopup.name"/>
		</div>
		<checkbox id="mailboxRoleIsExecutive" [(model)]="mailboxRolePopup.is_executive">
			Executive
		</checkbox>
	</div>
</popup-c>

<!--Threat Simulation template-->
<popup-c class="bs-enabled overflownV" *ngIf="threatSimulationPopup?.show"
		 head="Create Threat Simulation Template" size="dynamic"
		 subTitle="Create an email template to be used in Threat Simulation campaign"
		 (closeCb)="threatSimulationPopup.show = false; actionFinished();"
		 (confirmCb)="threatSimulationPopup?.doneCb()"
		 [buttons]="{cancel: !threatSimulationPopup.isCompleted && 'Cancel',
						 confirm: {text: threatSimulationPopup.isCompleted ? 'OK' : 'Confirm', loading: threatSimulationPopup.applyInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: visible;">
		<ng-container *ngIf="!threatSimulationPopup.isCompleted">
			<div class="flex-row gap-2 p-3 rounded-1 border" style="background: rgba(255,193,7,0.08); border-color: rgba(255,193,7,0.4) !important;" *ngIf="reviewerInfo.is_security_reviewer">
				<i class="far fa-exclamation-triangle text-warning mt-1"></i>
				<span style="font-size: 13px;">Security reviewer notice: this will add a SYSTEM Threat Simulation template available to all clients.</span>
			</div>

			<span>Fill in the details of the new template:</span>
			<br/>

			<div class="flex-row gap-1 align-items-center">
				<span class="flex-shrink-0" style="flex-basis: 105px;">Name:</span>
				<input type="text" class="f-1-0" [(ngModel)]="threatSimulationPopup.name"/>
			</div>

			<div class="flex-row gap-1 align-items-center">
				<span class="flex-shrink-0" style="flex-basis: 105px;">Description:</span>
				<input type="text" class="f-1-0" [(ngModel)]="threatSimulationPopup.description"/>
			</div>

			<div class="flex-row gap-1 align-items-center" *ngIf="threatSimulationPopup.linksList?.length">
				<div class="flex-row gap-1 align-items-center flex-shrink-0" style="flex-basis: 105px;">
					<span>Tracked link:</span>
					<i style="font-weight: 400;" class="far fa-question-circle"
					   tooltip='This link will be tracked to detect which users have clicked on it.'></i>
				</div>
				<app-dropdown-c class="f-1-0"
								[text]="threatSimulationPopup.selectedLink?.url || 'Select <small class=\'text-muted\'>(optional)</small>'"
								itemDisplayKey="url"
								[items]="threatSimulationPopup.linksList"
								(onItemClicked)="threatSimulationPopup.selectedLink = $event.item"></app-dropdown-c>
			</div>
		</ng-container>

		<ng-container *ngIf="threatSimulationPopup.isCompleted">
			<div class="flex-column f-1-0 align-items-center py-4 gap-3" style="font-size: 15px;">
				<span class="fw-500 align-self-center text-success text-center">Threat Simulation template created successfully!</span>
				<br/>
				<span class="align-self-center text-center">To review and edit this template go to <a class="blue-link" [routerLink]="['/' + dic.CONSTANTS.appStates.threatSimulation, dic.CONSTANTS.adminPages.threatSimulation.templates]">Threat Simulation Templates</a> page</span>
			</div>
		</ng-container>
	</div>
</popup-c>

<!--AI Training Material-->
<popup-c class="bs-enabled" *ngIf="aiTrainingMaterialPopup?.show"
		 head="Create Training Material with AI" size="large"
		 subTitle="Generate an AI-powered training video based on this email."
		 (closeCb)="aiTrainingMaterialPopup = null; actionFinished();"
		 (confirmCb)="generateAiTrainingMaterial();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Generate', loading: aiTrainingMaterialPopup.addMaterialsInProcess}}">
	<div class="flex-column overflow-auto f-1-0 pt-2 gap-2" style="padding: 20px; font-size: 15px;">
		<div class="list-group list-group-flush settings-list-container">
			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2">
					<b>Title</b>
					<span style="font-size: 0.9em;">The title of the material will be displayed on materials list</span>
				</div>
				<div class="content-container flex-column gap-3">
					<input class="m-0 w-100" type="text"
						   [(ngModel)]="aiTrainingMaterialPopup.data.title"
						   [ngClass]="{'validation-error' : aiTrainingMaterialPopup.error && !aiTrainingMaterialPopup.data.title}"
						   (keyup)="aiTrainingMaterialPopup.error = ''"
						   placeholder="Enter title">
				</div>
			</div>
			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2">
					<b>Video content</b>
					<span style="font-size: 0.9em;">Describe the overall topic of the video, the key points of focus, and what you want your audience to learn.</span>
				</div>
				<div class="content-container flex-column gap-3">
						<textarea class="m-0 color-equalized w-100" style="height: 135px;"
								  placeholder="Describe the training content for this email."
								  [(ngModel)]="aiTrainingMaterialPopup.data.description"></textarea>
					<div class="flex-row justify-content-between align-items-center">
						<span class="fw-500">Media <span class="text-muted fw-normal ms-2" style="font-size: 11px;">(Screenshot auto-captured)</span></span>
					</div>

					<div class="flex-row gap-2 align-items-center" *ngIf="aiTrainingMaterialPopup.captureInProcess">
						<loader height="20" width="20"></loader>
						<span>Capturing email content screenshot...</span>
					</div>

					<ng-container *ngIf="aiTrainingMaterialPopup.data.files.length">
						<div class="flex-row gap-3 align-items-center" *ngFor="let file of aiTrainingMaterialPopup.data.files">
							<div class="flxClmn-center hvr-opacity p-3" style="position: relative; cursor: pointer; align-items: center; border: solid 1px #e3e4e4; background: #fafafa; width: 100px; height: 100px;"
								 [tooltip]="file.fileData.name">
								<img [src]="'data:image/png;base64,' + file.previewBase64"
									 style="width: auto; height: auto; max-width: 100%; max-height: 100%;"/>
							</div>
							<textarea class="m-0 align-self-stretch h-auto color-equalized f-1-0"
									  placeholder="Visually describe this image. What does it show? What is its purpose?"
									  style="resize: none;"
									  [(ngModel)]="file.description"></textarea>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2">
					<b>Audience</b>
					<span style="font-size: 0.9em;">Selecting the audience will affect the video's content: jargon, methodics and overall focus.</span>
				</div>
				<div class="content-container flex-column gap-3">
					<app-dropdown-c class="w100" style="--bs-dropdown-max-height: min(24vh, 180px); --bs-dropdown-overflow: auto;"
									[text]="aiTrainingMaterialPopup.data.audience || 'Select'">
						<li *ngFor="let audience of aiTrainingAudienceOptions"
							(click)="aiTrainingMaterialPopup.data.audience = audience">
							{{audience}}
						</li>
					</app-dropdown-c>
				</div>
			</div>
			<div class="list-group-item settings-list-item py-4">
				<div class="title-section-container flex-column gap-2">
					<b>Video length</b>
					<span style="font-size: 0.9em;">Select the desired length of the video in minutes. The output video will roughly be at this length.</span>
				</div>
				<div class="content-container flex-column gap-3">
					<app-dropdown-c class="w100 show-above" [text]="aiTrainingMaterialPopup.data.videoLength.toString() + ' minute' + (aiTrainingMaterialPopup.data.videoLength >= 2 ? 's' : '')">
						<li *ngFor="let time of [1,1.5,2,2.5]"
							(click)="aiTrainingMaterialPopup.data.videoLength = time">
							{{time}} minute{{time >= 2 ? 's' : ''}}
						</li>
					</app-dropdown-c>
				</div>
			</div>
		</div>
	</div>
	<iframe #aiTrainingPreviewIframe
			*ngIf="aiTrainingMaterialPopup.previewHtml"
			[srcdoc]="aiTrainingMaterialPopup.previewHtml"
			(load)="captureAiTrainingScreenshot()"
			title="AI training screenshot preview"
			style="position: fixed; left: -10000px; top: -10000px; width: 1024px; height: 768px; opacity: 0; pointer-events: none; border: 0;"></iframe>
</popup-c>

<popup-c *ngIf="senderConnectionGraphPopup?.show"
		 head="Sender Connections Graph"
		 subTitle="A visualization of your users' connection network with the sender: <b>{{curTPResults.resHead.from.senderMailFrom}}</b>.<br/>Your users are labeled in green and their connections are in blue. <span class='fw-500'>Hover over a node to show its connections.</span>"
		 (closeCb)="senderConnectionGraphPopup = null; actionFinished();"
		 size="fullscreen">
	<div class="flxClmn f-1-0 vSpace1" *ngIf="!senderConnectionGraphPopup.loading">
		<div class="flxRow bs-enabled" style="align-items: center">
			<btn-c class="connected-to-right"
				   [variant]="senderConnectionGraphPopup.scope === 'sender' ? '' : 'outlined'"
				   (click)="updateConnectionGraphScope('sender')">
				Sender
			</btn-c>
			<btn-c class="connected-to-left"
				   [variant]="senderConnectionGraphPopup.scope === 'domain' ? '' : 'outlined'"
				   (click)="updateConnectionGraphScope('domain')">
				Domain
			</btn-c>
			<search-box [(model)]="senderConnectionGraphPopup.nodeSearchTxt"
						(modelChange)="searchConnectionEmailAddress()"
						[isDisabled]="_.isEmpty(senderConnectionGraphPopup.graphData)"
						style="width: 180px; margin-left: 15px;">
			</search-box>
			<span class="text-muted" style="margin-left: 10px;"
				  *ngIf="senderConnectionGraphPopup.nodeSearchTxt">
					{{senderConnectionGraphPopup.nodeSearchResults?.length || '0'}} result{{senderConnectionGraphPopup.nodeSearchResults?.length > 1 ? 's' : ''}}
				</span>
		</div>

		<div class="flxClmn f-1-0" [ngClass]="{'bg-light flxRow centralize' : _.isEmpty(senderConnectionGraphPopup.graphData)}">
					<span class="animated fadeIn" *ngIf="_.isEmpty(senderConnectionGraphPopup.graphData)">
						No emails were sent from users in plan to {{senderConnectionGraphPopup.scope === 'sender' ? 'sender:' : 'domain:'}}
						<span *ngIf="senderConnectionGraphPopup.scope === 'sender'" class="fw-500">{{curTPResults.resHead.from.senderMailFrom}}</span>
						<span *ngIf="senderConnectionGraphPopup.scope === 'domain'" class="fw-500">{{gs.getDomain(curTPResults.resHead.from.senderMailFrom)}}</span>
					</span>

			<echarts-graph class="flxClmn f-1-0"
							  [hidden]="_.isEmpty(senderConnectionGraphPopup.graphData)"
							  [showLegend]="false"
							  [nodeCfg]="graphNodeCfg"
							  [nodeOptionsFn]="senderConnectionGraphPopup.nodeOptionsFn"
							  [focusedNodesNames] = "senderConnectionGraphPopup.nodeSearchResults"
							  [rawGraphData]="senderConnectionGraphPopup.graphData"></echarts-graph>
		</div>
	</div>
	<!--Loader-->
	<div class="flxClmn centralize f-1-0" *ngIf="senderConnectionGraphPopup.loading">
		<loader class="opacity-75" height="80" width="80"></loader>
	</div>
	<!---->
</popup-c>

<preview-link-c
	*ngIf="openPreviewLinkPopup?.show"
	(cancelCb)="previewLink(false)"
	[url]="openPreviewLinkPopup.url">
</preview-link-c>

<attachment-preview
	*ngIf="previewAttachment"
	[attachment]="previewAttachment"
	(onClose)="previewAttachment = null;">
</attachment-preview>
